export default "__VITE_ASSET__DhWg5KgT__"